import React, { useEffect, useState } from "react";
import { Table, Switch } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deletePackage, getPackages, resetState } from "../features/package/packageSlice";
import CustomModal from "../components/CustomModal";
import axios from "axios";
import { base_url } from "../utils/baseUrl";

const PackageList = () => {
  const [open, setOpen] = useState(false);
  const [packageId, setPackageId] = useState("");

  const dispatch = useDispatch();
  const {  packages } = useSelector((state) => state.package) || [];
  console.log(packages);

  useEffect(() => {
    dispatch(resetState());
    dispatch(getPackages()); // Fetch package data via Redux
  }, [dispatch]);

  // Toggle Featured Status
  const handleToggleFeatured = async (id) => {
    console.log("Toggling featured status for Package ID:", id);

    if (!id) {
      console.error("Error: Package ID is undefined!");
      return;
    }

    try {
      const response = await axios.put(`${base_url}package/toggle-status/${id}`);

      if (response.status === 200) {
        console.log("Package featured status toggled successfully");
        dispatch(getPackages()); // Refresh Redux state after update
      }
    } catch (error) {
      console.error("Error toggling package status:", error);
    }
  };

  const showModal = (id) => {
    setOpen(true);
    setPackageId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const handleDeletePackage = (id) => {
    dispatch(deletePackage(id)).then(() => {
      dispatch(getPackages()); 
    });
    setOpen(false);
  };

  const columns = [
    { title: "SNo", dataIndex: "key" },
    { title: "Deal Name", dataIndex: "dealName" },
    { title: "Destination", dataIndex: "destination" },
    { title: "Duration", dataIndex: "duration" },
    { title: "Price (Same)", dataIndex: "priceForSame" },
    { title: "Price (Other)", dataIndex: "priceForOther" },
    { title: "Association", dataIndex: "association" }, // New column
    { title: "Member", dataIndex: "member" }, // New column
    {
      title: "Featured",
      dataIndex: "isFeatured",
    },
    { title: "Action", dataIndex: "action" },
  ];

  const dataSource = packages?.map((pkg, index) => ({
    key: index + 1,
    dealName: pkg.dealName,
    destination: pkg.destination,
    duration: pkg.duration,
    priceForSame: pkg.priceForSame,
    priceForOther: pkg.priceForOther,
    association: pkg.associationId ? pkg.associationId.shortName : "N/A", // Fetch Association Name
    member: pkg.memberId ? pkg.memberId.name : "N/A", // Fetch Member Name
    isFeatured: (
      <Switch checked={pkg.isFeatured} onChange={() => handleToggleFeatured(pkg._id)} />
    ),
    action: (
      <>
        {/* <Link to={`/admin/edit-package/${pkg._id}`} className="fs-3 text-primary">
          <BiEdit />
        </Link> */}
        <button className="ms-3 fs-3 text-danger bg-transparent border-0" onClick={() => showModal(pkg._id)}>
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  return (
    <div>
      <h3 className="mb-4 title">Package List</h3>
      <Table columns={columns} dataSource={dataSource} />
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => handleDeletePackage(packageId)}
        title="Are you sure you want to delete this package?"
      />
    </div>
  );
};

export default PackageList;
